module.exports = __webpack_public_path__ + "img/picture3.f4fffabb.webp";